// client/src/pages/Game/Battlefield/components/ResumeScreen.jsx
// Écran « une partie est en cours » affiché après un refresh (F5) au lieu
// du sélecteur de deck. Deux options : rejoindre la partie ou l'abandonner.
import React from 'react';
import Button from '../../../../components/ui/Button';

const ResumeScreen = ({ onRejoin, onAbandon, error, isRejoining }) => {
  return (
    <div className="battlefield-setup">
      <h2>⚔️ Une partie est en cours</h2>
      <p className="resume-hint">
        Vous avez actualisé la page pendant un duel. Votre partie est toujours
        active — vous pouvez la reprendre où vous l'aviez laissée.
      </p>
      {error && (
        <div className="error-message">
          <p>{error}</p>
        </div>
      )}
      <div className="deck-setup-actions">
        <Button type="outline" onClick={onAbandon}>
          Abandonner la partie
        </Button>
        <Button type="primary" onClick={onRejoin} disabled={isRejoining}>
          {isRejoining ? 'Reprise...' : 'Rejoindre la partie'}
        </Button>
      </div>
    </div>
  );
};

export default ResumeScreen;
